// First, so start-up errors are kept too: what the user may share with support when asked (a log request).
import './app/core/diagnostics/start-log-capture';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
//import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/* Sentry.init({
  dsn: "https://bc06f03a52c9d1d84e4eb5a8eb19d442@o4507655246053376.ingest.de.sentry.io/4507655247822928",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^\//],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: `medicai-client@${environment.APP_VERSION}`
}); */


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

/* if (environment.production && 'serviceWorker' in navigator) { */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/ngsw-worker.js')
      .then(registration => {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
      })
      .catch(error => {
        console.error('ServiceWorker registration failed: ', error);
      });
  });
}